import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class AbacusCourseList extends Component {
  state = {
    allCourses: [],
    message: "",
    notification: false,
    noticolor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getAllCourses();
  }

  /* ---------------- GET ALL COURSES ---------------- */
  getAllCourses = () => {
    if (init() === "success") {
      axios
        .get(Constants.getUrls.getAllAbacusCourses)
        .then((resp) => {
          console.log(resp);

          if (resp.data.status === "success" && Array.isArray(resp.data.data)) {
            this.setState({
              allCourses: resp.data.data,
            });
          } else {
            this.setState({ allCourses: [] });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.data?.message || "Failed to load courses",
          });

          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      this.setState({ redirect: true });
    }
  };

  /* ---------------- DELETE ---------------- */
  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteAbacusCourse + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState(
              {
                notification: true,
                noticolor: "success",
                message: resp.data.message,
              },
              () => this.getAllCourses()
            );

            setTimeout(() => {
              this.setState({ notification: false, message: "" });
            }, 2500);
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.data?.message || "Delete failed",
          });

          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      this.setState({ redirect: true });
    }
  };

  handleCloseSnackbar = () => {
    this.setState({ notification: false });
  };

  render() {
    const { redirect, allCourses, notification, message, noticolor } = this.state;

    if (redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Abacus Courses
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right" mt={2}>
              <Link to="/addabacuscourse">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>

            <MDBox p={2}>
              <DataTable
                canSearch={false}
                isSorted={false}
                table={{
                  columns: [
                    { Header: "Serial", accessor: "serial", width: "6%" },
                    { Header: "Title", accessor: "title" },
                    { Header: "Duration", accessor: "duration" },
                    { Header: "Action", accessor: "action" },
                  ],
                  rows: (allCourses || []).map((course, index) => ({
                    serial: index + 1,
                    title: course?.title || "-",
                    duration: course?.duration || "-",
                    action: (
                      <>
                        <div>
                          <Link to={`/updateabacuscourse/${course._id}`}>
                            <MDButton variant="outlined" size="small" color="success">
                              Update
                            </MDButton>
                          </Link>
                        </div>

                        <div style={{ marginTop: "1rem" }}>
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => this.handleDelete(course._id)}
                          >
                            Delete
                          </MDButton>
                        </div>
                      </>
                    ),
                  })),
                }}
              />
            </MDBox>

            <MDSnackbar
              open={notification}
              close={this.handleCloseSnackbar}
              color={noticolor}
              icon="notifications"
              title="Abacus Course"
              content={message}
              dateTime="Just now"
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
